import { HttpClient, HttpErrorResponse, HttpEvent, HttpResponse } from '@angular/common/http';
import { Injectable, Optional } from '@angular/core';
import { ConfigService } from 'core/config';
import { filterHttpResponse } from 'core/rx-js';
import { Observable, catchError, map, throwError } from 'rxjs';
import { v4 } from 'uuid';
import { HttpErrorHandler } from './http.error-handler';
import { HttpEventsInterceptor } from './http.events.interceptor';

@Injectable({ providedIn: 'root' })
export class ApiService {

  private readonly _handleHttpError = <T extends any>(errorHandler?: HttpErrorHandler) =>
    <T extends any>(obs: Observable<T>): Observable<T> =>
      obs.pipe(
        catchError((error: HttpErrorResponse) => {

          if (!errorHandler) {
            return throwError(() => ({ type: 'error', error }));
          }

          return errorHandler.handleError(error);
        }),
        // filter((passedObj) => (passedObj as any).type !== 'error'),
        map((passedObj) => passedObj as T)
      )

  private readonly _mapBody = <T extends any>() =>
    map((response: HttpResponse<T>) => response.body)


  private readonly intercept = <T extends any>(requestInfo?: { body: any, params: any, url: string }) => this._httpEventsInterceptor?.intercept<T>(requestInfo) || ((obs: Observable<HttpEvent<T>>) => obs)

  constructor(
    private readonly _configService: ConfigService,
    private readonly _httpClient: HttpClient,
    @Optional() private readonly _httpErrorHandler?: HttpErrorHandler,
    @Optional() private readonly _httpEventsInterceptor?: HttpEventsInterceptor,
  ) {

  }

  delete<T extends any>(path: string, params?: { [key: string]: string },) {

    return this._httpClient.delete<T>(this.getFullUrl(path), { params, observe: 'events', withCredentials: false },)
      .pipe(
        this.intercept({ body: null, params, url: this.getFullUrl(path) }),
        this._handleHttpError(this._httpErrorHandler),
        filterHttpResponse()
      )
  }

  get<T extends any = Object>(path: string, params?: { [key: string]: string | number | any[] | boolean, }, options?: { withCredentials: boolean }) {

    return this._httpClient.get<T>(this.getFullUrl(path), { params: this._clearUndefinedParams(params), observe: 'events', ...(options || {}) })
      .pipe(
        this.intercept({ body: null, params, url: this.getFullUrl(path) }),
        this._handleHttpError(this._httpErrorHandler),
        filterHttpResponse()
      )

  }

  post<T extends any = Object>(path: string, body: unknown, params?: { [key: string]: string }) {
    const requestId = v4();

    return this._httpClient.post<T>(this.getFullUrl(path), body, { params, observe: 'events' })
      .pipe(
        this.intercept({ body, params, url: this.getFullUrl(path) }),
        this._handleHttpError(this._httpErrorHandler),
        filterHttpResponse()
      )

  }

  put<T extends any = Object>(path: string, body?: unknown, params?: { [key: string]: string }) {

    return this._httpClient.put<T>(this.getFullUrl(path), body, { params, observe: 'events' })
      .pipe(
        this.intercept({ body, params, url: this.getFullUrl(path) }),
        this._handleHttpError(this._httpErrorHandler),
        filterHttpResponse()
      )

  }


  getFullUrl(path: string) {

    return (this._configService.appConfig?.api.url || '') + '/' + (this._configService.appConfig?.api.contextRoot || '') + '/' + path
  }

  private _clearUndefinedParams(params: any) {

    if (!params) {
      return params;
    }

    Object.entries(params).forEach(([key, value]) => {
      if (value === undefined) {
        delete params[key]
      }
    })

    return params;
  }



  private _joinUrls(...parts: string[]) {

  }
}
